import { HttpInterceptorFn } from '@angular/common/http';

export const guestTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const guestToken = sessionStorage.getItem('guestToken');
  // Só adiciona se não houver Authorization já presente
  if (guestToken && !req.headers.has('Authorization')) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${guestToken}`
      }
    });
  }
  return next(req);
}; 